"use client";

import dynamic from "next/dynamic";
import { GoogleAnalytics } from "@next/third-parties/google";
import { useDeferredReady } from "./useDeferredReady";

// FacebookPixel is client-only; code-split it so its bundle isn't fetched until
// we actually mount it (after idle/interaction).
const FacebookPixel = dynamic(
  () => import("@/client/components/facebook/FacebookPixel"),
  { ssr: false }
);

// Loads Google Analytics + Facebook Pixel only after the browser is idle or the
// user interacts, keeping their scripts off the critical path on first load.
export function DeferredAnalytics({ gaId }: { gaId: string }) {
  const ready = useDeferredReady();

  if (!ready) return null;

  return (
    <>
      <GoogleAnalytics gaId={gaId} />
      <FacebookPixel />
    </>
  );
}
